module.exports = __webpack_public_path__ + "static/img/banner.35e89e50.jpg";